import os from "node:os";
import path from "node:path";
import { mkdirSync } from "node:fs";

function expandHomeDir(input: string): string {
  if (input.startsWith("~/")) {
    return path.join(os.homedir(), input.slice(2));
  }
  if (input === "~") {
    return os.homedir();
  }
  return input;
}

export function resolveAppostleHome(env: NodeJS.ProcessEnv = process.env): string {
  const raw = env.APPOSTLE_HOME ?? "~/.appostle";
  const resolved = path.resolve(expandHomeDir(raw));
  mkdirSync(resolved, { recursive: true });
  return resolved;
}
